// mc-vsl-ux.js, bundle-ux 2026-10-16 (builder B3). Loaded with defer by sections/mc-boutique-vsl.liquid, so it runs
// after the page's inline script has defined P, SEL, FIRM, money, esc, selectSize and selectFirm, and before the page
// is built on DOMContentLoaded. The inline script keeps only the variant from the address (so the buy box opens on it)
// and one line hooks: MCVSLUX.afterBuild(), afterRender(cart), opened(), closed(fromPop) and atc(form).
// What lives here:
// - the header and sticky bar buttons: "Choose size", then "Choose firmness" on mattresses with a feel choice, then
//   "Add to cart", which adds the chosen size and feel through the same add as the main button, and the bars show the
//   choice and price
// - every size or feel tap writes ?variant= into the address (history.replaceState), so Back and a refresh keep it
// - How it feels names the chosen feel on mattresses with a feel choice; the trial accordion links the Return Hub
// - a failed add shows a plain message under the button and the page stays
// - the cart panel (#mcqc): delivery line with a green tick only for a free metro postcode, spend reward wording, one
//   named line per discount, the welcome and bundle notes, Discounts at checkout, a Delivery line above Total
// - Back closes the cart panel; closing it another way takes its history entry off; links inside it leave by replacing
//   that entry, so Back from checkout comes straight back to this page
(function () {
  'use strict';
  if (typeof P === 'undefined' || !P || !P.product || window.MCVSLUX) return;

  var CHOSE_SIZE = false, CHOSE_FIRM = false, inFirm = false;
  function needsFirm() { return !!(P.product.firmness && P.product.firmness.options && P.product.firmness.options.length > 1); }
  function urlVariant() { try { return new URLSearchParams(location.search).get('variant'); } catch (e) { return null; } }
  (function () { var v = urlVariant(), s = P.product.sizes[SEL]; if (v && s && String(s.variantId) === v) { CHOSE_SIZE = true; CHOSE_FIRM = true; } })();

  function syncUrl() {
    try {
      var s = P.product.sizes[SEL];
      if (!s || !s.variantId || !history.replaceState) return;
      var u = new URL(location.href);
      if (u.searchParams.get('variant') === String(s.variantId)) return;
      u.searchParams.set('variant', String(s.variantId));
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  function barState() { if (!CHOSE_SIZE) return 'size'; if (needsFirm() && !CHOSE_FIRM) return 'firm'; return 'add'; }
  function choiceText() { var s = P.product.sizes[SEL]; return s ? s.label + (needsFirm() && FIRM && CHOSE_FIRM ? ' · ' + FIRM : '') : ''; }
  function bars() {
    var s = P.product.sizes[SEL]; if (!s) return;
    var st = barState(), choice = choiceText();
    var label = st === 'add' ? 'Add to cart' : st === 'firm' ? 'Choose firmness' : 'Choose size';
    document.querySelectorAll('[data-mc-baradd]').forEach(function (b) {
      if (b.classList.contains('is-busy')) return;
      b.textContent = label;
      b.setAttribute('aria-label', st === 'add' ? 'Add ' + choice + ' to your cart for ' + money(s.price) : label);
    });
    var c = document.getElementById('sb-choice'); if (c) c.textContent = choice;
    var pr = document.getElementById('sb-price'); if (pr) pr.textContent = money(s.price);
    var hd = document.getElementById('hdprice'); if (hd) hd.innerHTML = esc(choice) + '<b>' + money(s.price) + '</b>';
  }
  // until the shopper has chosen, the bar buttons go to the size (or firmness) buttons in the top buy box
  function goChoose(st) {
    var top = document.getElementById('top'); if (!top) return;
    var row = st === 'firm' ? top.querySelector('[data-firmrow]') : top.querySelector('.size-chips');
    if (!row) return;
    var lbl = row.previousElementSibling && row.previousElementSibling.classList.contains('buy-lbl') ? row.previousElementSibling : row;
    var hd = document.getElementById('mcvsl-hd');
    window.scrollTo({ top: Math.max(0, lbl.getBoundingClientRect().top + window.scrollY - (hd ? hd.offsetHeight : 0) - 16), behavior: 'smooth' });
    var sel = row.querySelector('.size-chip.sel') || row.querySelector('.size-chip');
    if (sel) setTimeout(function () { try { sel.focus({ preventScroll: true }); } catch (e) {} }, 500);
  }
  function barClick(e) {
    e.preventDefault();
    var st = barState();
    if (st !== 'add') { goChoose(st); return; }
    var form = document.querySelector('#buy-main form.js-atc-form') || document.querySelector('form.js-atc-form');
    if (form) atc(form, e.currentTarget);
  }

  // the size and feel taps (inline onclick handlers and the page's own calls go through these)
  var origSize = window.selectSize, origFirm = window.selectFirm;
  if (typeof origSize === 'function') window.selectSize = function (i, quiet) { origSize(i); if (!quiet && !inFirm) { CHOSE_SIZE = true; syncUrl(); } bars(); };
  if (typeof origFirm === 'function') window.selectFirm = function (f, quiet) { inFirm = true; try { origFirm(f); } finally { inFirm = false; } if (!quiet) { CHOSE_FIRM = true; syncUrl(); } bars(); };

  // How it feels on a mattress with a feel choice names the chosen feel; the sentences that pinned one feel lose only
  // that clause. No new feel claims: spec truth has no per feel text for this range.
  function dropFixedFeel(t) {
    var out = String(t || '')
      .replace(/^The [^.]*? has an? [a-z ]+? feel\.\s*/i, '')
      .replace(/ has an? [a-z ]+? feel built around /i, ' is built around ')
      .replace(/ has an? [a-z ]+? feel, with /i, ' has ')
      .trim();
    return /\bhas an? [a-z ]+? feel\b/i.test(out) ? '' : out;
  }
  function feelPanel() {
    var D = window.MCX_SNAP;
    if (!needsFirm() || !D || !D.feel) return;
    var d = [].slice.call(document.querySelectorAll('.k-acc details')).filter(function (x) { return /How it feels/.test(x.querySelector('summary').textContent); })[0];
    var body = d && d.querySelector('.k-body'); if (!body) return;
    var fo = P.product.firmness.options, list = fo.slice(0, -1).join(', ') + ' and ' + fo[fo.length - 1];
    var paras = (D.feel.body || []).map(dropFixedFeel).filter(Boolean);
    body.innerHTML = '<p><b>You choose the feel.</b> This mattress comes in ' + fo.length + ' feels: ' + esc(list) + '. The one you pick above is the one you get, and right now that is <b data-firmname>' + esc(FIRM) + '</b>.</p>' + paras.map(function (p) { return '<p>' + esc(p) + '</p>'; }).join('');
  }
  // the trial accordion ends with the Return Hub link, as in the 120 nights box above it
  function trialLink() {
    var d = [].slice.call(document.querySelectorAll('.k-acc details')).filter(function (x) { return /trial/i.test(x.querySelector('summary').textContent); })[0];
    var body = d && d.querySelector('.k-body');
    if (body && !body.querySelector('a[href="/pages/returns-hub"]')) body.insertAdjacentHTML('beforeend', '<p><a class="k-quiz" href="/pages/returns-hub">How returns work</a></p>');
  }
  function afterBuild() {
    document.querySelectorAll('[data-mc-baradd]').forEach(function (b) { if (!b.__mcWired) { b.__mcWired = true; b.addEventListener('click', barClick); } });
    feelPanel();
    trialLink();
    bars();
  }

  // ---------- cart panel (#mcqc) ----------
  var css = document.createElement('style');
  css.textContent = [
    '#mcqc .qc-rw-main.is-neutral svg{color:var(--ink-2)}',
    '#mcqc .qc-row.qc-disc b{color:var(--green);font-weight:600}',
    '#mcqc .qc-row.qc-w5-note{font-size:12.5px;line-height:1.4;padding-top:0}',
    '#mcqc .qc-row.qc-del b{color:var(--ink);font-weight:600}',
    '#mcqc .qc-row.qc-del a{color:var(--ink);font-weight:600;text-decoration:underline;text-underline-offset:2px;padding:6px 0}',
    '#mcqc .mcab,#mcqc .mcab-sec{min-width:0}',
    'html.mc-cart-open shopify-chat{display:none !important}'
  ].join('\n');
  document.head.appendChild(css);

  var M = function () { return window.__mcMini || {}; };
  var fmt = function (c) { return '$' + (c % 100 === 0 ? (c / 100).toLocaleString('en-AU') : (c / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })); };
  var checkIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="m8 12.5 2.6 2.6L16 9.5"/></svg>';
  var truckIcon = '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 8h14v12H3zM17 12h6l4 4v4h-10z"/><circle cx="9" cy="23" r="2.4"/><circle cx="22" cy="23" r="2.4"/></svg>';
  var lastCart = null;

  // the delivery line follows the postcode checked with the delivery checker (assets/mc-delivery.js); only a free
  // metro postcode gets the green tick
  function delivery() {
    var pc = ''; try { pc = (localStorage.getItem('mc_postcode') || '').trim(); } catch (e) {}
    if (!/^\d{4}$/.test(pc) || !window.MC_ZONES) return { kind: 'none', text: 'Free delivery to metro areas' };
    var z = window.MC_ZONES[pc], where = (z && z[0] ? z[0] + ' ' : '') + pc;
    return z && (z[1] === 'free' || z[1] === 'free-nextday') ? { kind: 'free', text: 'Free delivery to ' + where } : { kind: 'priced', text: 'Delivery to ' + where + ' is priced at checkout before you pay' };
  }
  // the same names as the theme drawer and cart page (builder B4)
  function discLabel(t) {
    var T = String(t || '').toUpperCase(), m;
    if (T === 'WELCOME5') return 'Welcome discount (5 percent, first order)';
    if (T === 'SENIORS10-SO4G') return 'Seniors Card (10 percent)';
    if (/^BEDROOM(10|15|20)/.test(T)) return 'Bedroom bundle saving';
    if ((m = T.match(/^CART(10|20|30|40|50)$/))) { var n = Number(m[1]); return 'Spend reward (' + fmt(n * 100) + ' off over ' + fmt(n * 10000) + ')'; }
    if (T === 'CART100') return 'Spend reward';
    if (/BUNDLE SAVING/.test(T)) return 'Bundle saving';
    return String(t || 'Discount');
  }
  function discRows(cart) {
    var sums = {}, order = [];
    var add = function (t, a) { a = Number(a || 0); if (!t || !(a > 0)) return; if (!(t in sums)) { sums[t] = 0; order.push(t); } sums[t] += a; };
    (cart.cart_level_discount_applications || []).forEach(function (d) { d = d && d.discount_application ? d.discount_application : d; add(d && (d.title || d.key), d && d.total_allocated_amount); });
    (cart.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (x) { var d = x && x.discount_application; add(d && (d.title || d.key), x && x.amount); }); });
    return order.map(function (t) { return { t: t, a: sums[t] }; });
  }
  function bundleNote(rows) {
    var n = 0, w5 = false;
    rows.forEach(function (r) { var T = String(r.t).toUpperCase(), m = T.match(/^BEDROOM(10|15|20)/); if (m) n = Math.max(n, Number(m[1])); if (T === 'WELCOME5') w5 = true; });
    return n && w5 ? '<div class="qc-row qc-w5-note"><span>Together your bundle and welcome discounts take ' + n + ' percent off the pieces that go with your mattress.</span></div>' : '';
  }
  function afterRender(cart) {
    lastCart = cart;
    var panel = document.getElementById('mcqc'); if (!panel) return;
    var dl = delivery();
    var L = window.MCAddonLadder, rv = L && L.rewardView ? L.rewardView(cart) : null;
    var rw = panel.querySelector('.qc-rewards');
    if (rw && rv) {
      var tier = rv.applied, remaining = rv.remaining;
      var html = '<div class="qc-rw-main' + (dl.kind === 'free' ? '' : ' is-neutral') + '">' + (dl.kind === 'free' ? checkIcon : truckIcon) + esc(dl.text) + '</div>';
      if (tier > 0 && tier >= 5) html += '<div class="qc-rw-sub">The top $50 spend reward is on your order.</div>';
      else if (tier > 0) html += '<div class="qc-rw-sub">A $' + (tier * 10) + ' spend reward is on your order.</div>' + (remaining > 0 ? '<div class="qc-rw-sub">Spend ' + fmt(remaining) + ' more and $' + ((tier + 1) * 10) + ' comes off your order.</div>' : '');
      else if (remaining > 0) html += '<div class="qc-rw-sub">Spend ' + fmt(remaining) + ' more and $10 comes off your order.</div>';
      [].slice.call(rw.children).forEach(function (n) { if (!n.classList.contains('qc-track')) n.remove(); });
      rw.insertAdjacentHTML('afterbegin', html);
    }
    var sum = panel.querySelector('.qc-sum');
    if (sum && cart.item_count > 0) {
      var rows = discRows(cart);
      var total = cart.total_discount || rows.reduce(function (a, r) { return a + r.a; }, 0);
      var sub = cart.original_total_price != null ? cart.original_total_price : (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
      sum.innerHTML =
        '<div class="qc-row"><span>Subtotal</span><b>' + fmt(sub) + '</b></div>' +
        rows.map(function (r) {
          return '<div class="qc-row qc-disc"><span>' + esc(discLabel(r.t)) + '</span><b>-' + fmt(r.a) + '</b></div>' +
            (String(r.t).toUpperCase() === 'WELCOME5' ? '<div class="qc-row qc-w5-note"><span>If you have ordered with us before, this discount will not apply at checkout.</span></div>' : '');
        }).join('') +
        bundleNote(rows) +
        (rows.length > 1 && total > 0 ? '<div class="qc-row qc-savings"><span>Discounts at checkout</span><b>-' + fmt(total) + '</b></div>' : '') +
        '<div class="qc-row qc-del"><span>Delivery</span>' + (dl.kind === 'free' ? '<b>Free</b>' : dl.kind === 'priced' ? '<b>Priced at checkout</b>' : '<a href="/cart#mc-check-delivery" data-qc-check-pc>Check your postcode</a>') + '</div>' +
        '<div class="qc-row qc-total"><span>Total</span><span>' + fmt(cart.total_price) + '</span></div>';
    }
  }
  document.addEventListener('mc:postcode', function () { if (lastCart && M().render) M().render(lastCart); });

  // Back closes the panel (the same as the theme drawer, builder B4)
  var pushed = false, ignorePop = false, afterUnwind = null, safety = null, pendingAfterClose = null;
  function finishUnwind() { ignorePop = false; clearTimeout(safety); var f = afterUnwind; afterUnwind = null; if (f) f(); }
  function unwind(then) {
    if (!pushed) { if (then) then(); return; }
    pushed = false; ignorePop = true; afterUnwind = then || null;
    history.back();
    safety = setTimeout(function () { if (ignorePop) finishUnwind(); }, 700);
  }
  function opened() {
    document.documentElement.classList.add('mc-cart-open');
    if (history.pushState && !pushed && !ignorePop) { try { history.pushState({ mcCart: 1 }, ''); pushed = true; } catch (e) {} }
  }
  function closed(fromPop) {
    document.documentElement.classList.remove('mc-cart-open');
    var then = pendingAfterClose; pendingAfterClose = null;
    if (!fromPop && pushed) unwind(then ? function () { setTimeout(then, 30); } : null);
    else if (then) then();
  }
  function panelOpen() { var p = document.getElementById('mcqc'); return !!(p && p.classList.contains('open')); }
  window.addEventListener('popstate', function () {
    if (ignorePop) { finishUnwind(); return; }
    if (!pushed || !panelOpen()) return;
    pushed = false;
    if (M().closeDrawer) M().closeDrawer(true);
  });
  // back from the cart or checkout restores this page from the browser cache with the panel still drawn open
  window.addEventListener('pageshow', function (e) { if (e.persisted && !pushed && panelOpen() && M().closeDrawer) M().closeDrawer(true); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('#mcqc a[href]') : null;
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.hasAttribute('data-qc-check-pc')) {
      // on a mattress page the postcode box is in the top buy box: close the panel and put the cursor there
      var inp = document.querySelector('#top [data-mc-postcode]') || document.querySelector('[data-mc-postcode]');
      if (!inp || !M().closeDrawer) return;
      e.preventDefault();
      pendingAfterClose = function () { inp.scrollIntoView({ block: 'center' }); try { inp.focus({ preventScroll: true }); } catch (err) { inp.focus(); } };
      M().closeDrawer();
      return;
    }
    if (!pushed || (a.target && a.target !== '_self') || /^(mailto:|tel:|#|javascript:)/i.test(a.getAttribute('href') || '')) return;
    // leave by replacing the panel's history entry, so Back from checkout comes straight back here
    e.preventDefault();
    pushed = false;
    location.replace(a.href);
  });

  // one add path for the buy box buttons and the bar buttons; a failed add says so under the button and the page stays
  function atcMsg(form, show) {
    var host = form.parentNode, m = host ? host.querySelector('.mc-atc-err') : null;
    if (!show) { if (m) m.remove(); return null; }
    if (!m) { m = document.createElement('p'); m.className = 'mc-atc-err'; m.setAttribute('role', 'alert'); form.insertAdjacentElement('afterend', m); }
    m.innerHTML = 'Sorry, that did not go into your cart. Please try again. If it keeps happening, <a href="/pages/sleep-consultation">book a free call</a> and we will sort it out.';
    return m;
  }
  function atc(form, trigger) {
    if (form.__mcBusy) return;
    form.__mcBusy = true;
    var btn = form.querySelector('button[type="submit"]');
    var shown = [btn, trigger].filter(Boolean), labels = shown.map(function (b) { return b.textContent; });
    shown.forEach(function (b) { b.classList.add('is-busy'); if (b.tagName === 'BUTTON') b.disabled = true; b.textContent = 'Adding'; });
    atcMsg(form, false);
    var fd = new FormData(form);
    fd.append('sections', 'mc-cart-json');
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add failed ' + r.status); return r.json(); })
      .then(function (res) {
        return Promise.resolve()
          .then(function () { return M().fastRefresh(res && res.sections && res.sections['mc-cart-json']); })
          .catch(function () { return M().refresh(); })
          .then(function () { M().openDrawer(); })
          .catch(function () { window.top.location.href = '/cart'; });
      }, function () {
        var m = atcMsg(form, true);
        if (m && trigger) { var r = m.getBoundingClientRect(); if (r.top < 90 || r.bottom > window.innerHeight - 90) m.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      })
      .then(function () {
        form.__mcBusy = false;
        shown.forEach(function (b, i) { b.classList.remove('is-busy'); if (b.tagName === 'BUTTON') b.disabled = false; b.textContent = labels[i]; });
        bars();
      });
  }

  window.MCVSLUX = { afterBuild: afterBuild, afterRender: afterRender, opened: opened, closed: closed, atc: atc };
  // if the page was built before this file ran (the theme editor), finish it now
  if (document.getElementById('buy-main')) afterBuild();
})();
